import type { TFunction } from 'i18next'
import type { legacyHU } from './resources/legacy-hu.ts'

/** Translate a compile-time checked key from the compatibility namespace. */
export const translateLegacy = (t: TFunction, key: keyof typeof legacyHU | ''): string =>
	key ? t(key, { ns: 'translation' }) : ''
